import { useMutation } from '@tanstack/react-query';
import vlqrApi from 'utils/vlqrApi';

const useCreateHighlightRequest = () => {
    const { mutate, isLoading } = useMutation({
        mutationFn: highlight => vlqrApi.post('VideoHighlights', highlight)
    });

    return { mutate, isLoading };
};

export default useCreateHighlightRequest;
